export * from './utils/array-record.js';
export * from './utils/date.js';
export * from './utils/number.js';
export * from './utils/object.js';
export * from './utils/url.js';
export * from './utils/zod.js';
export * from './utils/map-set.js';
export const waitForMs = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const intSequenceExcl = (start, end) => {
    return Array(end - start - 1)
        .fill(start + 1)
        .map((n, i) => n + i);
};
export const charSequence = (a, b) => {
    const aCode = a.charCodeAt(0);
    const bCode = b.charCodeAt(0);
    const length = bCode - aCode + 1;
    return Array.from({ length }, (_, i) => String.fromCharCode(aCode + i));
};
export const BASE64_URL_CHARSET = [
    charSequence('a', 'z'),
    charSequence('A', 'Z'),
    charSequence('1', '9'),
    '0',
    '-',
    '_',
].flat();
//# sourceMappingURL=utils.js.map